export default __webpack_public_path__ + "static/media/cern-extrabold.0e23e429.woff";